import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M5.5 2.875c.345 0 .625.28.625.625v4a.625.625 0 1 1-1.25 0v-4c0-.345.28-.625.625-.625Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2.875c.345 0 .625.28.625.625v3.45a2.626 2.626 0 1 1-1.25 0V3.5c0-.345.28-.625.625-.625Zm0 5.25a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.5 2.875c.345 0 .625.28.625.625v6a.625.625 0 1 1-1.25 0v-6c0-.345.28-.625.625-.625Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M2.875 12.5a2.625 2.625 0 1 1 3.25 2.55v5.45a.625.625 0 1 1-1.25 0v-5.45a2.626 2.626 0 0 1-2-2.55ZM5.5 11.125a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75ZM15.875 14.5a2.625 2.625 0 1 1 3.25 2.55v3.45a.625.625 0 1 1-1.25 0v-3.45a2.626 2.626 0 0 1-2-2.55Zm2.625-1.375a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12 13.875c.345 0 .625.28.625.625v6a.625.625 0 1 1-1.25 0v-6c0-.345.28-.625.625-.625Z"
    />
  </svg>
`;
